"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTrackingCookieAllowed = void 0;
var types_1 = require("../types");
var isNavigatorTrackingAllowed_1 = require("./isNavigatorTrackingAllowed");
/**
 * - TRUE  - tracking allowed (i.e. user clicked "Allow")
 * - FALSE - tracking disallowed (i.e. user clicked "Disallow" or browser "Do Not Track" mode is ON)
 * - NULL  - unknown (i.e. user didn't click anything yet, and no browser preference set)
 */
function isTrackingCookieAllowed(consent, newsroom) {
    if ((newsroom === null || newsroom === void 0 ? void 0 : newsroom.tracking_policy) === types_1.TrackingPolicy.DISABLED) {
        return false;
    }
    if (consent !== null) {
        return consent;
    }
    if ((0, isNavigatorTrackingAllowed_1.isNavigatorTrackingAllowed)() === false) {
        return false; // "Disallow tracking" -- no need to ask consent
    }
    // Both "Allow navigator tracking" and "no preference" require us to ask a consent.
    return null;
}
exports.isTrackingCookieAllowed = isTrackingCookieAllowed;
//# sourceMappingURL=isTrackingCookieAllowed.js.map